<div class="w-full animal-form" [formGroup]="formGroup()">
  <div class="flex flex-col w-full">
    <div class="flex flex-row items-center gap-8 mb-4">
        <div class="flex flex-col">
            <p class="mb-2 radio-label" [class.disabled]="formGroup().get('type')?.disabled">
                {{ 'chipRegistration.animal.selectAnimalType' | translate }}*
            </p>
            <div class="flex flex-wrap gap-4">
                <div class="flex items-center">
                    <p-radiobutton formControlName="type" inputId="dog" name="type" [value]="animalTypes[0]" (onClick)="animalTypeChanged($event)" />
                    <label class="ml-2" for="dog">{{ 'chipRegistration.animal.dog' | translate }}</label>
                </div>
                <div class="flex items-center">
                    <p-radiobutton formControlName="type" inputId="cat" name="type" [value]="animalTypes[1]" (onClick)="animalTypeChanged($event)" />
                    <label class="ml-2" for="cat">{{ 'chipRegistration.animal.cat' | translate }}</label>
                </div>
                <div class="flex items-center">
                    <p-radiobutton formControlName="type" inputId="rabbitFerry" name="type" [value]="animalTypes[2]" (onClick)="animalTypeChanged($event)" />
                    <label class="ml-2" for="rabbitFerry">{{ 'chipRegistration.animal.rabbitFerry' | translate }}</label>
                </div>
            </div>
        </div>

        @if (formGroup().get('type')?.value !== 'rabbitFerry') {
            <p-floatlabel variant="in">
                <p-select class="w-64" formControlName="breed" id="animal-breed-id" optionLabel="name" optionValue="id" [options]="breedsList" />
                <label for="animal-breed-id">{{ "chipRegistration.animal.breed" | translate }}</label>
            </p-floatlabel>
        }

        <p-floatlabel variant="in">
            <input class="w-64" formControlName="name" id="animal-name-id" pInputText required="true" type="text" />
            <label for="animal-name-id">{{ 'chipRegistration.animal.name' | translate }}*</label>
        </p-floatlabel>
    </div>

    <div class="flex flex-row items-center gap-8 mb-4">
        <p-floatlabel variant="in">
            <p-select class="w-64" formControlName="sex" id="animal-sex-id" optionLabel="name" optionValue="id" [options]="sexList">
                <ng-template #selectedItem let-selectedOption>
                    @if (formGroup().get('sex')?.value) {
                        <div class="flex items-center gap-2">
                            {{ selectedOption.name | translate}}
                        </div>
                    }
                </ng-template>
                <ng-template #item let-sexOption>
                    <div class="flex items-center gap-2">
                        {{ sexOption.name | translate}}
                    </div>
                </ng-template>
            </p-select>
            <label for="animal-sex-id">{{ "chipRegistration.animal.sex" | translate }}</label>
        </p-floatlabel>

        <p-floatlabel variant="in">
            <p-select class="w-64" formControlName="chipLocation" id="animal-chip-location-id" optionLabel="name" optionValue="id" [options]="chipLocationList">
                <ng-template #selectedItem let-selectedOption>
                    @if (formGroup().get('chipLocation')?.value) {
                        <div class="flex items-center gap-2">
                            {{ selectedOption.name | translate}}
                        </div>
                    }
                </ng-template>
                <ng-template #item let-chipLocationOption>
                    <div class="flex items-center gap-2">
                        {{ chipLocationOption.name | translate}}
                    </div>
                </ng-template>
            </p-select>
            <label for="animal-chip-location-id">{{ "chipRegistration.animal.chipLocation" | translate }}</label>
        </p-floatlabel>

        <p-floatlabel variant="in">
            <p-select class="w-64" formControlName="coatType" id="animal-coat-type-id" optionLabel="name" optionValue="id" [options]="coatTypeList">
                <ng-template #selectedItem let-selectedOption>
                    @if (formGroup().get('coatType')?.value) {
                        <div class="flex items-center gap-2">
                            {{ selectedOption.name | translate}}
                        </div>
                    }
                </ng-template>
                <ng-template #item let-coatTypeOption>
                    <div class="flex items-center gap-2">
                        {{ coatTypeOption.name | translate}}
                    </div>
                </ng-template>
            </p-select>
            <label for="animal-coat-type-id">{{ "chipRegistration.animal.coatType" | translate }}</label>
        </p-floatlabel>
    </div>

    <div class="flex flex-row items-center gap-8 mb-4">

        <p-floatlabel variant="in">
            <p-datepicker class="w-64" formControlName="dateOfBirth" id="dateOfBirth" showIcon="true" [maxDate]="today" [readonlyInput]="true" [required]="true" />
            <label for="dateOfBirth">{{ 'chipRegistration.animal.dateOfBirth' | translate }}*</label>
        </p-floatlabel>

        <p-floatlabel variant="in">
            <p-select class="w-64" formControlName="size" id="animal-size-id" optionLabel="name" optionValue="id" [options]="sizeList">
                <ng-template #selectedItem let-selectedOption>
                    @if (formGroup().get('size')?.value) {
                        <div class="flex items-center gap-2">
                            {{ selectedOption.name | translate}}
                        </div>
                    }
                </ng-template>
                <ng-template #item let-sizeOption>
                    <div class="flex items-center gap-2">
                        {{ sizeOption.name | translate}}
                    </div>
                </ng-template>
            </p-select>
            <label for="animal-size-id">{{ "chipRegistration.animal.size" | translate }}</label>
        </p-floatlabel>

        <div class="flex flex-row items-center gap-2">
            <p-checkbox formControlName="castrated" inputId="castrated" [binary]="true" [required]="false" />
            <label for="castrated">{{ "chipRegistration.animal.castrated" | translate }}*</label>
        </div>
    </div>

    <div class="flex flex-row items-center gap-2">
        <p-checkbox formControlName="isAddressSameAsOwner" inputId="isAddressSameAsOwner" [binary]="true" [required]="false" />
        <label for="isAddressSameAsOwner">{{ "chipRegistration.animal.addressAsOwner" | translate }}*</label>
    </div>
  </div>
</div>


